//!esta carpeta va a tener todos los tipes de mi aplicacion para usarlo en el rediurcer
//en use reducer moy a llamar este odjeto

export const types = {
    login: '[auth] login',
    logout: '[auth] logout',
}